


import { useState } from "react";
import { registerUser } from "../authService";
import VQRegisterPage from "./VQRegisterPage";
import { useLanguage } from "../i18n/LanguageProvider";

function RegisterPage({ onBackToLogin }) {
  const { t, language } = useLanguage();
  const [error, setError] = useState("");

  const handleRegister = async (payload) => {
    setError("");

    const username = String(payload?.username || "").trim();

    // ✅ USERNAME VALIDIERUNG
    const USERNAME_REGEX = /^[a-zA-Z0-9_]{3,15}$/;

    const RESERVED_USERNAMES = [
      "admin",
      "support",
      "vaultquest",
      "official",
      "moderator",
      "system",
    ];

    if (!USERNAME_REGEX.test(username)) {
      return setError(t("register.errors.usernameInvalid"));
    }

    if (RESERVED_USERNAMES.includes(username.toLowerCase())) {
      return setError(t("register.errors.usernameReserved"));
    }

    const age = String(payload?.age || "").trim();
    const email = String(payload?.email || "").trim();
    const password = String(payload?.password || "");
    const passwordRepeat = String(payload?.passwordRepeat || "");
    const acceptedLegal = Boolean(payload?.acceptedLegal);
    const confirmedMinimumAge = Boolean(payload?.confirmedMinimumAge);
    const consoleType = String(payload?.consoleType || "").trim();

    // 1) Basic Checks (nur UI)
    if (!username) return setError(t("register.errors.usernameRequired"));
    if (!confirmedMinimumAge)
      return setError(t("register.errors.minimumAgeConfirmationRequired"));
    if (!acceptedLegal)
      return setError(t("register.errors.acceptLegalRequired"));
    if (!email) return setError(t("register.errors.emailRequired"));
    if (!password) return setError(t("register.errors.passwordRequired"));
    if (password.length < 6)
      return setError(t("register.errors.passwordTooShort"));
    if (password !== passwordRepeat)
      return setError(t("register.errors.passwordMismatch"));
    if (!consoleType)
      return setError(t("register.errors.consoleTypeRequired"));

    // 2) Firebase Registrierung
    try {
      await registerUser(
        email,
        password,
        username,
        age,
        consoleType,
        language,
        payload?.aiConflictAnalysisConsent === true
      );
    } catch (err) {
      console.error("Registration error:", err?.code || err?.message || "unknown");

      if (err?.code === "auth/weak-password") {
        setError(t("register.errors.passwordTooShort"));
        return;
      }

     if (
  err?.message === "INVALID_EMAIL" ||
  err?.code === "auth/invalid-email"
) {
  setError(t("register.errors.invalidEmail"));
  return;
}

      if (err?.message === "USERNAME_ALREADY_TAKEN") {
        setError(t("register.errors.emailOrUsernameTaken"));
        return;
      }

      if (err?.message === "INVALID_USERNAME") {
        setError(t("register.errors.usernameInvalid"));
        return;
      }

      if (err?.message === "RESERVED_USERNAME") {
        setError(t("register.errors.usernameReserved"));
        return;
      }

      if (err?.message === "USERNAME_NOT_ALLOWED") {
  setError(t("register.errors.usernameNotAllowed"));
  return;
}

      if (err?.code === "auth/email-already-in-use") {
        setError(t("register.errors.emailOrUsernameTaken"));
        return;
      }

      setError(t("register.errors.generic"));
    }
  };

  return (
    <VQRegisterPage
      onBackToLogin={onBackToLogin}
      onRegister={handleRegister}
      error={error}
      onAppleError={setError}
    />
  );
}

export default RegisterPage;
